import CrmRepository from "./CrmRepository";

const resource = "/customer-growers";
export default {
  getAll(params) {
    return CrmRepository.get(`${resource}?limit=all`, { params });
  },

  get(id, params) {
    return CrmRepository.get(`${resource}/${id}`, { params });
  },

  create(payload) {
    return CrmRepository.post(resource, payload);
  },

  update(id, payload) {
    return CrmRepository.put(`${resource}/${id}`, payload);
  },

  suspend(id) {
    return CrmRepository.delete(`${resource}/${id}`);
  },

  deleteBatch(payload) {
    return CrmRepository.delete(resource, { data: { id: payload } });
  }
};